import { createAsyncThunk } from '@reduxjs/toolkit'
import { isCommonResponseSuccessful, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithoutParams } from 'src/mentor/services'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import {
  selectAppointmentCalendarSettings,
  setAppointmentCalendarSettingsData,
  setAppointmentCalendarSettingsError,
  setAppointmentCalendarSettingsStatus,
} from '../prescriptionReducer'
import { REDUX_STATUS_LOADING } from 'src/consumer/constants'

// Thunk
export const getAppointmentCalendarSettings = createAsyncThunk(
  'prescriptionStore/appointmentCalendarSettings/get',
  async ({ appointmentCalendarSettingsGetApiSignature }, { getState, dispatch }) => {
    const state = getState()
    const existingData = selectAppointmentCalendarSettings(state)?.data

    console.log({ calData: selectAppointmentCalendarSettings(state), existingData })
    // If data exists, update state to 'success' and continue silently
    if (existingData) {
      dispatch(setAppointmentCalendarSettingsData(existingData))
      return existingData
    } else {
      dispatch(setAppointmentCalendarSettingsStatus(REDUX_STATUS_LOADING))
    }

    try {
      // Check if this is a support portal API
      const isSupportPortalApi = appointmentCalendarSettingsGetApiSignature.includes('/api/secure/cc/support/')
      
      let resp
      if (isSupportPortalApi) {
        // Parse query params from URL if present
        const urlParts = appointmentCalendarSettingsGetApiSignature.split('?')
        const pathname = urlParts[0]
        const params = {}
        
        // Extract query params if present
        if (urlParts.length > 1) {
          const queryString = urlParts[1]
          const searchParams = new URLSearchParams(queryString)
          searchParams.forEach((value, key) => {
            params[key] = value
          })
        }
        
        resp = await getSPDataWithParams(pathname, params)
        
        if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
          const data = resp?.data?.data || resp?.data || {}
          const appointmentCalendarSettings = data?.appointmentCalendarSettings || data
          dispatch(setAppointmentCalendarSettingsData(appointmentCalendarSettings))
          dispatch(setAppointmentCalendarSettingsStatus('success'))
        } else {
          throw new Error('Invalid response from API')
        }
      } else {
        // Mentor portal API
        resp = await getMPDataWithoutParams(
          appointmentCalendarSettingsGetApiSignature,
        )
        if (resp?.status === 200 && isCommonResponseSuccessful(resp?.data?.code)) {
          // Update store silently with new data
          dispatch(setAppointmentCalendarSettingsData(resp?.data?.data?.appointmentCalendarSettings))
          dispatch(setAppointmentCalendarSettingsStatus('success'))
        } else {
          throw new Error('Invalid response from API')
        }
      }
    } catch (error) {
      dispatch(setAppointmentCalendarSettingsError(error.message || 'Failed to fetch data'))
      dispatch(setAppointmentCalendarSettingsError('error'))
    }
  },
)
